<template>
	<div>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" :style="{ 'min-height': '100vh' }">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="list">
					<template v-for="(item, index) in list">
						<reward :item="item"></reward>
					</template>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
import reward from '@/components/list/reward.vue';
export default {
	data() {
		return {
			page: 0,
			pageSize: 20,
			list: [],
			loading: false,
			finished: false,
			refreshing: false
		};
	},
	components: {
		reward
	},
	methods: {
		onLoad() {
			if (this.refreshing) {
				this.list = [];
				this.refreshing = false;
			} else {
				console.log('onLoad');
				this.loading = true;
				this.page++;

				this.$service
					.post('user_info/viewHistory', {
						page: this.page,
						pageSize: this.pageSize
					})
					.then(res => {
						let data = res.data.data;
						this.list = this.list.concat(data);
						this.loading = false;
						if (data.length < this.pageSize) {
							this.finished = true;
						}
					});
			}
		},
		onRefresh() {
			console.log('onRefresh');
			this.page = 0;
			this.finished = false;
			this.refreshing = true;
			this.onLoad();
		}
	}
};
</script>

<style scoped lang="less">
@import './history.less';
</style>
